import React, { useEffect, useState } from "react";
import DataTableLayer from "../../components/DataTableLayer";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import PostByAgg from "../../utils/axios";
import { useAuth } from "../../context/AuthContext";
import CatalogueForm from "./CatalogueForm";
import LottieLoading from "../../components/child/LottieLoading";
import ModalAlert from "../../components/ModalAlert";
import Image from "../../assets/No_cover.png"


const Catalogue = () => {

  const [viewDetails,setViewDetails] = useState(false)
  const [selectedRowView,setSelectedRowView] = useState({})
  const [previewImage, setPreviewImage] = useState(null);
  const [isLoading,setIsLoading] = useState(false)
  const [modalOpen,setModalOpen] = useState(<div></div>)
   const [listReleaseLabel, setListRealeaseLabel] = useState([]);
      const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    })

    const {musicLabelCode,roleCode} = useAuth()

    const columns = [
          // {
          //     accessorKey: "music_label_name",
          //     key:'Label Name',
          //     header: "Label Name",
          // },
          {
            header: "Judul",
            accessorKey:"title"
          },
          {
            header: "Cover",
            accessorKey: "image_url",
            cell: ({ row }) => {
              const imageUrl = row.getValue("image_url");
              const defaultImage = Image;
              return (
                <img
                  src={imageUrl ? imageUrl : defaultImage}
                  alt="Cover"
                  style={{ width: "50px", height: "auto", borderRadius: "4px" }}
                />
              );
            },
          },
          {
            header: "SubJudul",
            accessorKey:"sub_title"
          },
          {
              header:"Genre",
              accessorKey:"genre_name",
          },
          {
            header: "SubGenre",
            accessorKey: "sub_genre_name",
          },
          {
            header: "Release Type",
            accessorKey: "release_type_name",
          },
          {
            header: "P line",
            accessorKey: "i_inline",
          },
          {
              header: "C line",
              accessorKey: "c_inline",
          },
          {
            header:"Status",
            accessorKey:"status_name",
            cell:({row})=>{
            const status = row.getValue("status_name");
                let badgeColor;
            switch (status) {
                case "WAITING":
                badgeColor = "bg-warning";
                break;
                case "LIVE":
                badgeColor = "bg-danger";
                break;
                default:
                badgeColor = "bg-success";
                break;
            }
                return (
                  <span onClick={() => {}} className={`badge ${badgeColor}`}>{status}</span>
                );
            },
          },
        {
            accessorKey: "action", // Add a custom column for actions
            header: "Actions",
            cell: ({ row }) => (
               <div className="dropdown">
                    <button
                        className="btn px-18 py-11 text-primary-light"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <Icon
                            icon="ph:dots-three-outline-fill"
                            className="menu-icon"
                        />
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={()=> handleAction("view",row)}
                            >
                                View
                            </Link>
                        </li>
                    </ul>
               </div>
            ),
          },
      ];
    

      const GetListReleaseLabel = () => {
        setIsLoading(true)
        const url = 'song/v1/release/list-by-music-label-code';
        PostByAgg({
            url: url,
            body: {
                "music_label_code": musicLabelCode,
                "page": pagination.pageIndex + 1,
                "page_size": pagination.totalRecords,
            },
            onResponse:onResponseListRelease,
            onError:onErrorListRelease
        })
     }

     
     
     const onResponseListRelease = (response) => {
      
       console.log("Response List Release Label: ", response.data.data)
       if(response.data.data.data === null || response.data.code === '2002000'){
        setIsLoading(false)
         const totalRecords = response.data.data.total_records;
         const totalPages = Math.ceil(totalRecords / pagination.pageSize);
         setPagination((prev) => ({
           ...prev,
           totalRecords: totalRecords,
           totalPages: totalPages,
           pageSize:totalRecords
           // pageIndex: 0,
          }));
          setListRealeaseLabel(response.data.data.data || [])
        }else{
          setIsLoading(false)
          setListRealeaseLabel([])
        }
      }
      
      const onErrorListRelease = (error) => {
        console.log("Error List Label: ", error)
        setModalOpen(
          <ModalAlert
            show={true}
            type={"failed"}
            text={error.response.data}
            action={() => {}}
            />
        )
    }

    //   const GetFindByReleaseCode =  () => {
    //     const url = 'song/v1/release/find-by-release-code';
    //     const releaseCode = selectedRowView.row.original.release_code
    //     PostByAgg({
    //       url: url,
    //       body:{
    //         "release_code": releaseCode
    //       },
    //       onResponse:onResponseFindByRelease,
    //       onError:onErrorFindByRelease
    //     })

    //   }

    //   function onResponseFindByRelease(response) {
    //     console.log("Response Find By Release Code: ", response.data.data)
    //     if(response.data.data) {
    //       setSelectedRowView(response.data.data)
    //       setViewDetails(true)
    //     }
    //   }

    //   function onErrorFindByRelease(error) {
    //     console.log("Error Find By Release Code: ", error)
    // }
    
  
  useEffect(() => {  
   GetListReleaseLabel();
  }, [pagination.pageIndex, pagination.pageSize]);

  const handleAction = (action, row) => {
    // Handle different actions based on the clicked item
    console.log(`Action: ${action}, Row ID: ${row.original.id}`);
    console.log(row)
    if (action === 'view') {
      setViewDetails(true)
      setSelectedRowView(row)

      setPreviewImage(row.original.image_url)
    } 
    // else if (action === 'edit') {
    //   // Logic to edit
    // } else if (action === 'delete') {
    //   // Logic to delete
    // }
  };

  const handleCloseModalView = () => {
    setViewDetails(false);
    setSelectedRowView('')
  };


    
    return (
        <div>
           <DataTableLayer
            data={listReleaseLabel} 
            columns={columns} 
            title={"List Release"} 
            pagination={pagination} 
            handleAction={handleAction}
            showButton={roleCode === 'RL2411062373407' ? true : false }/>

           {
            viewDetails &&(
              <CatalogueForm
                  previewImage={previewImage}
                  setPreviewImage={setPreviewImage}
                  data={selectedRowView}
                  open={viewDetails}
                  mode="view"
                  onClose={handleCloseModalView}
                  onSubmit={()=>{}}
                  />
            )
           }
           {isLoading && <LottieLoading text="Loading..." />}
           {modalOpen}
        </div>
        
    );
};

export default Catalogue;